import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Spin, message } from "antd";
import Bridge from "./utils/Bridge";

export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: "",
      new_password: "",
      confirm_password: "",
      confirm_type: "password",
      new_type: "password",
      old_type: "password",
      loading: false,
    };
  }
  componentDidMount() {}
  // show hide password
  togglePassword = (type) => {
    if (type == "confirm") {
      this.setState({
        confirm_type:
          this.state.confirm_type == "password" ? "text" : "password",
      });
    } else if (type == "new") {
      this.setState({
        new_type: this.state.new_type == "password" ? "text" : "password",
      });
    } else if (type == "old") {
      this.setState({
        old_type: this.state.old_type == "password" ? "text" : "password",
      });
    }
  };
  change_password = () => {
    if (!this.state.old_password) {
      message.warning("Please enter old password first.");
      return;
    } else if (!this.state.new_password) {
      message.warning("Please enter old password.");
      return;
    } else if (!this.state.confirm_password) {
      message.warning("Please enter confirm password.");
      return;
    }
    if (this.state.new_password.length < 8) {
      message.warning(
        "New Password length must be greater than or equal to 8 characters."
      );
      return;
    }
    if (this.state.new_password != this.state.confirm_password) {
      message.warning("New Password and Confirm Password is not matching.");
      return;
    }
    let params = {
      old_password: this.state.old_password,
      new_password: this.state.new_password,
      participant_id: localStorage.getItem("ap_id"),
      participants_accounts_id:localStorage.getItem("ap_participants_accounts_id")
    };
    this.setState({ loading: true });
    Bridge.change_password(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState({
            old_password: "",
            new_password: "",
            confirm_password: "",
            loading: false,
          });
        } else {
          message.warning(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try again!!");
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header />
        <div
          className="main-content demographics-wrapper"
          style={{ paddingTop: 40 }}
        >
          <div className="container" style={{ minHeight: 300 }}>
            <div className="row">
              <div className="col-lg-6">
                <a href="/dashboard" className="dashboard-back-arrow mt-0">
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Dashboard
                </a>
                <Spin spinning={this.state.loading}>
                  <div className="change-password-form">
                    <h3 className="pb-0 mb-0">Change Password</h3>
                    <hr />
                    <div className="form-group pt-4">
                      <label>
                        <box-icon
                          type="solid"
                          name="envelope"
                          color="#9e9e9e"
                          size="23px"
                          style={{ marginTop: 0, marginRight: 12 }}
                        ></box-icon>{" "}
                        Old Password
                      </label>
                      <input
                        type={this.state.old_type}
                        value={this.state.old_password}
                        onChange={(e) =>
                          this.setState({ old_password: e.target.value })
                        }
                      />
                      <div
                        className="togglePassword"
                        onClick={() => this.togglePassword("old")}
                      >
                        {this.state.old_type == "password" ? (
                          <div className="show-password-icon">
                            <box-icon name="show" color="#ffa3a3"></box-icon>
                          </div>
                        ) : (
                          <div className="show-password-icon">
                            <box-icon
                              name="low-vision"
                              color="#ffa3a3"
                            ></box-icon>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <label>
                        <box-icon
                          type="solid"
                          name="envelope"
                          color="#9e9e9e"
                          size="23px"
                          style={{ marginTop: 0, marginRight: 12 }}
                        ></box-icon>{" "}
                        New Password
                      </label>
                      <input
                        type={this.state.new_type}
                        value={this.state.new_password}
                        onChange={(e) =>
                          this.setState({ new_password: e.target.value })
                        }
                      />
                      <div
                        className="togglePassword"
                        onClick={() => this.togglePassword("new")}
                      >
                        {this.state.new_type == "password" ? (
                          <div className="show-password-icon">
                            <box-icon name="show" color="#ffa3a3"></box-icon>
                          </div>
                        ) : (
                          <div className="show-password-icon">
                            <box-icon
                              name="low-vision"
                              color="#ffa3a3"
                            ></box-icon>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <label>
                        <box-icon
                          type="solid"
                          name="envelope"
                          color="#9e9e9e"
                          size="23px"
                          style={{ marginTop: 0, marginRight: 12 }}
                        ></box-icon>{" "}
                        Confirm Password
                      </label>
                      <input
                        type={this.state.confirm_type}
                        value={this.state.confirm_password}
                        onChange={(e) =>
                          this.setState({ confirm_password: e.target.value })
                        }
                      />
                      <div
                        className="togglePassword"
                        onClick={() => this.togglePassword("confirm")}
                      >
                        {this.state.confirm_type == "password" ? (
                          <div className="show-password-icon">
                            <box-icon name="show" color="#ffa3a3"></box-icon>
                          </div>
                        ) : (
                          <div className="show-password-icon">
                            <box-icon
                              name="low-vision"
                              color="#ffa3a3"
                            ></box-icon>
                          </div>
                        )}
                      </div>
                    </div>
                    <button
                      className="submit-button"
                      onClick={() => this.change_password()}
                    >
                      Change Password{" "}
                      <box-icon
                        name="chevron-right"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                    </button>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
